function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function makeRegExp(string, modifiers) {
	return new RegExp(escapeRegExp(string), modifiers);
}
